import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MainHeader from "../../components/common/MainHeader";
import { GET, POST } from "../../utils/HttpClient";
import { URL_INTERFACE_AX, URL_POST_BAKING } from "../../constance/urls";
import { Toast } from "../../utils/Toast";
import ErrorMessage from "../../components/common/ErrorMessage";
import InterfaceAXHistoryModal from "../../components/interface_ax/InterfaceAXHistoryModal";
import {
  INTERFACE_TYPE,
  WASTE_WOOD_ORDER_TYPE,
} from "../../constance/dataTypes";
import { formatComma } from "../../utils/stringFormat";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";
import TSTable from "../../components/common/TSTable";
import {
  Tag,
  Tabs,
  List,
  Form,
  Space,
  DatePicker,
  Typography,
  Tooltip,
} from "antd";
import {
  SortAscendingOutlined,
  LoginOutlined,
  CheckOutlined,
  CloseOutlined,
  FileTextFilled,
} from "@ant-design/icons";
import { BLUE_COLOR } from "../../constance/color";
import ColorButton from "../../components/common/ColorButton";

export default function InterfaceAxWasteWoodOrderView() {
  const { t } = useTranslation();
  const countRef = React.useRef();
  const inputRef = React.useRef();

  const [openHistory, setOpenHistory] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [activeIndex, setAciveIndex] = React.useState();

  const { TabPane } = Tabs;
  const [form] = Form.useForm();
  const date = Form.useWatch("post_baking_group_date", form);
  const [allowInterfaceAX, setAllowInterfaceAX] = React.useState(true);
  const isFormValid = React.useMemo(
    () => !!date && allowInterfaceAX,
    [date, allowInterfaceAX]
  );

  const [totalInputCount, setTotalInputCount] = React.useState(0)
  const [countInputCount, setCountInputCount] = React.useState(0)

  const resetTable = () => {
    if (countRef.current) {
      countRef.current.clear();
    }
    if (inputRef.current) {
      inputRef.current.clear();
    }
  };


  const countColumns = React.useMemo(
    () => [
      {
        title: t("post_baking_waste_wood_count.group_date"),
        dataIndex: "post_baking_group_date",
        render: (text, record) =>
          dayjs(record.post_baking_group_date).format(HUMAN_DATE_FORMAT) || "-",
      },
      {
        title: t("post_baking_waste_wood_count.oven"),
        dataIndex: "ovens",
        render: (text, record) => {
          if (!record || !record.length) {
            return t("post_baking_waste_wood_count.all_oven");
          }
          return record.join(", ");
        },
      },
      {
        title: t("wood_size"),
        dataIndex: "wood_size_amount_map_list",
        render: (_, original) => {
          const value = original?.wood_size_amount_map_list?.filter(
            (el) =>
              el?.waste_wood_order_type === WASTE_WOOD_ORDER_TYPE.SHAPING_TYPE
          );
          return value && value.length > 0 ? (
            <List>
              {value
                .filter((data) => data?.amount > 0)
                .map((data, index) => (
                  <List.Item key={index}>
                    {data?.wood_code} - {`(${formatComma(data?.amount)})`}{" "}
                    {formatComma(data?.volume)}
                  </List.Item>
                ))}
            </List>
          ) : (
            "-"
          );
        },
      },

      {
        title: t("interface_ax.is_interfaced"),
        dataIndex: "is_interfaced_order",
        render: (_, record) => {
          const data = record?.wood_size_amount_map_list?.filter(
            (item) =>
              item?.waste_wood_order_type ===
                WASTE_WOOD_ORDER_TYPE.SHAPING_TYPE && item?.amount > 0
          );

          return data.length ? (
            <List
              size="small"
              dataSource={data}
              renderItem={(item) => (
                <List.Item key={item.id}>
                  {item.is_interfaced_order ? (
                    <CheckOutlined style={{ color: "green" }} />
                  ) : (
                    <CloseOutlined style={{ color: "red" }} />
                  )}
                </List.Item>
              )}
            />
          ) : (
            "-"
          );
        },
      },
    ],
    [date]
  );

  const inputColumns = React.useMemo(
    () => [
      {
        title: t("barcodes.barcode_id"),
        dataIndex: "barcode",
      },
      {
        title: t("post_baking_waste_wood_count.group_date"),
        dataIndex: "post_baking_group_date",
        render: (text, record) =>
          dayjs(record.post_baking_group_date).format(HUMAN_DATE_FORMAT) || "-",
      },
      {
        title: t("wood_size"),
        dataIndex: "wood_size_amount_map_list",
        render: (_, original) => {
          const value = original?.wood_size_amount_map_list?.filter(
            (el) =>
              el?.waste_wood_order_type === WASTE_WOOD_ORDER_TYPE.SHAPING_TYPE
          );
          return value && value.length > 0 ? (
            <List>
              {value
                .filter((data) => data?.amount > 0)
                .map((data, index) => (
                  <List.Item key={index}>
                    {data?.wood_code} - {`(${formatComma(data?.amount)})`}{" "}
                    {formatComma(data?.volume)}
                  </List.Item>
                ))}
            </List>
          ) : (
            "-"
          );
        },
      },
      {
        title: t("interface_ax.is_interfaced"),
        dataIndex: "is_interfaced_order",
        render: (_, record) => {
          const data = record?.wood_size_amount_map_list?.filter(
            (item) =>
              item?.waste_wood_order_type ===
                WASTE_WOOD_ORDER_TYPE.SHAPING_TYPE && item?.amount > 0
          );

          return data.length ? (
            <List
              size="small"
              dataSource={data}
              renderItem={(item) => (
                <List.Item key={item.id}>
                  {item.is_interfaced_order ? (
                    <CheckOutlined style={{ color: "green" }} />
                  ) : (
                    <CloseOutlined style={{ color: "red" }} />
                  )}
                </List.Item>
              )}
            />
          ) : (
            "-"
          );
        },
      },
    ],
    [date]
  );

  const handleDoInterfaceAX = async () => {
    if (!isFormValid) {
      setErrorMessages(t("error_messages.validation.required"));
      return;
    }
    setLoading(true);
    setErrorMessages(null);
    try {
      await POST(URL_INTERFACE_AX.WASTE_WOOD_ORDER, {
        date: dayjs(date).format(DATE_FORMAT),
      });
      resetTable();
      Toast.info(t("progressing"));
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    countRef.current.fetch();
    inputRef.current.fetch();
  }, [date]);


  return (
    <div style={{ margin: "24px", marginTop: "7em" }}>
      <MainHeader />

      <Typography.Title level={2}>
        {t("menus.interface_ax")}:{" "}
        {t("menus.interface_ax_menus.waste_wood_order")}
      </Typography.Title>

      <Form layout="inline" form={form}>
        <Space>
          <Form.Item
            label={t("post_baking_waste_wood_count.group_date")}
            name="post_baking_group_date"
            rules={[{ required: true }]}
          >
            <DatePicker
              format={HUMAN_DATE_FORMAT}
              placeholder={t("searchs.fields.date")}
            />
          </Form.Item>
          <Form.Item name="interface_ax.history">
            <ColorButton
              variant="outlined"
              color="primary"
              override={BLUE_COLOR}
              icon={<FileTextFilled />}
              onClick={() => setOpenHistory(true)}
            >
              {t("interface_ax.history")}
            </ColorButton>
          </Form.Item>
          <Tooltip
            placement="bottom"
            title={
              !isFormValid ? t("select") + " " + t("searchs.fields.date") : ""
            }
          >
            <ColorButton
              type="primary"
              override={BLUE_COLOR}
              loading={loading}
              disabled={!isFormValid}
              onClick={() => handleDoInterfaceAX()}
            >
              {t("interface_ax.submit")}
            </ColorButton>
          </Tooltip>
        </Space>
      </Form>

      <ErrorMessage message={errorMessages} length={100} />

      <Tabs
        tabBarStyle={{ marginBottom: 0 }}
        onTabChange={(__, { activeIndex }) => setAciveIndex(activeIndex)}
      >
        <TabPane
          tab={
            <Space>
              <SortAscendingOutlined />
              {t("menus.wood_menus.post_baking_waste_wood_count")}
              <Tag color="default">{countInputCount ?? 0}</Tag>
            </Space>
          }
          key="truck_transaction_detail"
        >
          <TSTable
            scroll={{ x: 1000 }}
            style={{ marginTop: "24px" }}
            ref={countRef}
            columns={countColumns}
            url={date ? URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT : ""}
            manual
            params={{
              date_after: date ? dayjs(date).format(DATE_FORMAT) : null,
              date_before: date ? dayjs(date).format(DATE_FORMAT) : null,
              order_type: WASTE_WOOD_ORDER_TYPE.SHAPING_TYPE,
            }}
            onData={() => {
              setCountInputCount(countRef.current.getTotal())
            }}
          />
        </TabPane>

        <TabPane
          tab={
            <Space>
              <LoginOutlined />
              {t("menus.wood_menus.post_baking_waste_wood_input")}
              <Tag color="default">{totalInputCount ?? 0}</Tag>
            </Space>
          }
          key="summary"
          forceRender
        >
          <TSTable
            scroll={{ x: 1000 }}
            style={{ marginTop: "24px" }}
            ref={inputRef}
            columns={inputColumns}
            url={
              date
                ? URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION
                : ""
            }
            manual
            params={{
              date_after: date ? dayjs(date).format(DATE_FORMAT) : null,
              date_before: date ? dayjs(date).format(DATE_FORMAT) : null,
              order_type: WASTE_WOOD_ORDER_TYPE.SHAPING_TYPE,
            }}
            onData={()=> {
              setTotalInputCount(inputRef.current.getTotal())
            }}
          />
        </TabPane>
      </Tabs>

      <InterfaceAXHistoryModal
        open={openHistory}
        onClose={() => setOpenHistory(false)}
        type={INTERFACE_TYPE.WASTE_WOOD_ORDER}
      />
    </div>
  );
}
